module.exports = __webpack_public_path__ + "img/horizontal-rule.8c6719d4.svg";